<template>
    <section class="configurations-page">
        <section class="title">
            <h1>Outras Configurações</h1>
            <p>Selecione as opções desejadas</p>
        </section>
        <section class="cards">
            <form v-on:submit.prevent="update" v-if="!load">
                <div class="input-box input-select">
                    <select v-model="form.new_user_register">
                        <option v-for="role in roles" :key="role.id" :value="role.slug">{{role.name}}</option>
                    </select>
                    <label>
                        <span>Tipo de usuário para novos registros:</span>
                    </label>
                </div>
                <div class="input-box input-select">
                    <select v-model="form.tickets_users_owners">
                        <option v-for="role in roles" :key="role.id" :value="role.slug">{{role.name}}</option>
                    </select>
                    <label>
                        <span>Tipo de usuário responsável pelos atendimentos dos tickets:</span>
                    </label>
                </div>
                <div class="control">
                    <button type="submit" :class="indicator">Salvar alterações</button>
                </div>
            </form>
            <section class="load" v-if="load"></section>
        </section>
    </section>
</template>

<script>
    import mixinAutoResize from "../../../../mixins/auto-resize.js";
    import { roles, configurations } from "@/services"
    export default {
        name: 'login',
        components: {},
        mixins: [ mixinAutoResize ],
        data() {
            return {
                roles: [],
                load: false,
                loadUpdate: false,
                form: {
                    new_user_register: '',
                    tickets_users_owners: '',
                }
            }
        },
        computed: {
            indicator(){
                return this.loadUpdate ? 'loading' : ''
            }
        },
        methods: {
            getRoles(){
                roles.read().then( response => {
                    this.roles = [...this.roles, ...response.data]
                })
            },
            getConfigurations(){
                this.load = true
                configurations.list().then( response => {
                    this.form = response.data
                    this.load = false
                })
            },
            update(){
                this.loadUpdate = true
                configurations.update(this.form).then( () => {
                    this.loadUpdate = false
                })
            }
        },
        created(){
			this.getRoles()
			this.getConfigurations()
		}
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
